<template>
    <section class="view spacer">
        <vue-headful
            title="Grants View | What goes into a Grants View"
            description="Grants View identifies the functional and financial composition of your grant portfolio, tracking key indicators. Analyze performance throughout the solicitation, award, and execution process."
            url="https://www.fedsight.com/grants-view"
        />
        <section class='container-fluid d-flex align-items-center justify-content-center'>
        </section>

        <section class='viewIntro'>
            <div class='container'>
                <h1 class='viewHeader fedsightBlue'>GRANTS VIEW</h1> 
                <p class='viewMainParagraph'>
                    Grants View enables analysts and managers to more effectively plan, manage, and evaluate grants individually and collectively. Examine and report on grants from multiple perspectives including program, recipient, organization, type, duration, and funding levels. Look at historical trends and benchmarks to inform incremental and more significant adjustments. Reports and forecasting models streamline the entire grants management life-cycle. Analysts can view grants from multiple perspectives, manage risk more proactively, and identify opportunities to enhance program performance.
                </p>
            </div>
            
        </section>

        <section class='blogPost'>
            <div class='container blogPostContainer'>
                <h2 class='fedsightBlue' style='margin-top: 0rem;'>
                    Key Business Questions:
                </h2>
                <ul>
                    <li>
                        What is the composition of your organizations current grants portfolio and to what extent are there opportunities to create efficiency? 
                    </li>
                    <li>
                        Is your grants portfolio optimized to meet programmatic and mission goals and how well are you performing against targets?
                    </li>
                    <li>
                        To what extent do grants overlap organizationally, programmatically, or geographically for similar support?
                    </li>
                    <li>
                        Are you getting the best value and rates at the lowest level of indirect expenses?
                    </li>
                    <li>
                        To what extent are funds “sitting” on grants for extended periods of time with little or no draw down and what are the trends by organization and function?
                    </li>
                    <li>
                        How have you historically used contracts vs. grants or federal employees to execute key functions and is the balance in sync with mission  and cost objectives?
                    </li>
                    <li>
                        What is are your administrative costs per grant, from acquisition to close-out, and is the grant portfolio optimized to meet business and risk/compliance objectives?
                    </li>
                </ul>
            </div>

            <div class='container blogPostContainer'>
                <h2 class='fedsightBlue' style='margin-top: 0rem;'>
                    Who we are
                </h2>
                <p>
                    Fedsight Consulting is an SBA certified HUBZone small business consulting firm focused on helping organizations improve operations and program performance. Our strategic, financial, and operational support services provide insight and perspective on program performance and operational trends.  Fedsight Consulting’s subject matter expertise, methods, and tools enable federal organizations to accomplish objectives, effectively manage resources, and improve program performance.
                </p>
                <p>
                    To learn more about Fedsight Consulting and discuss potential opportunities, email <span class='emailLink' @click='emailUs()'>info@fedsight.com</span>.
                </p>
            </div>
        </section>

        <Footer />
  </section>
</template>

<script>
import Footer from '@/components/Footer.vue'
import closeMenu from '../../mixins/closeMenu'


export default {
    name: 'grants-view',
    components: {
        Footer
    },
    metaInfo: {
      link: [
        {rel:'canonical', href:'https://www.fedsight.com/grants-view'}
      ]
    },
    mixins: [closeMenu],
    methods: {
      emailUs(){
          window.location.href = "mailto:info@fedsight.com?subject=I%20would%20like%20to%20learn%20more%20about%20Fedsight&body=Hello,%0D%0A%0D%0APlease%20contact%20me%20to%20discuss%20how%20Fedsight%20can%20assist%20my%20company.%0D%0A%0D%0A";
      }
    },
    mounted() {
        document.dispatchEvent(new Event('page.rendered'));
    }
}
</script>

<style scoped>
.viewIntro{
    padding: 8rem 0rem 2rem;
    max-width: 100rem;
    margin: auto;
    text-align: left;
}
.viewHeader{
    font-size: 4rem;
    font-weight: bold;
    text-align: center;
    /*background-color: #132631;
    color: #fff; */
    width: 100%;
    padding: 2rem 0rem;
}
.blogPost{
    text-align: left;
}
.blogPostContainer{
    max-width: 100rem;
    margin: 3rem auto;
}
.viewHero{
    height: 30rem;
}
.viewHeader{
    color: #fff;
    font-size: 6rem;
}
.emailLink{
    color: #007bff;
    cursor: pointer;
}
.emailLink:hover{
    color: #0056b3;
    text-decoration: underline;
}
h2{
    margin-top: 3rem;
}


/* Small devices (landscape phones, 576px and up) */
  @media (max-width: 576px) { 
    .slogan {
      font-size: 3.5rem !important;
    }
  }

  @media (max-width: 768px) { 
    .slogan{
      text-align: center;
      margin-left: auto;
      margin-right: auto;
    }
  }

  @media (max-width: 992px){
    .container{
        padding: 1.5rem !important;
    }
  }

  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) { 
    
    .slogan {
      font-size: 9rem !important;
    }
  }
</style>